import React, { useState } from 'react';
import { Button } from './ui/button.tsx';
import { Checkbox } from './ui/checkbox.tsx'; // Assuming this component exists in shadcn/ui
import { toast } from 'react-toastify';

interface ToastContentWithCheckboxProps {
  messageId: string;
  text: string;
  closeToast?: () => void; // Provided by react-toastify
  onDismiss: (messageId: string) => Promise<void>; // Function to mark as seen in DB
}

const ToastContentWithCheckbox: React.FC<ToastContentWithCheckboxProps> = ({
  messageId,
  text,
  closeToast,
  onDismiss,
}) => {
  const [isDismissedChecked, setIsDismissedChecked] = useState(false);

  const handleActionClick = async () => {
    if (isDismissedChecked) {
      await onDismiss(messageId); // Mark as seen in IndexedDB
      if (closeToast) {
        closeToast(); // Close the toast after dismissing permanently
      }
    } else {
      // If checkbox is not checked, just close the toast.
      // It will reappear on next relevant API call because it's not marked as seen.
      if (closeToast) {
        closeToast();
      }
    }
  };

  return (
    <div className="flex flex-col p-2">
      <p className="mb-3 text-sm">{text}</p>
      <div className="flex items-center space-x-2 mb-3">
        <Checkbox
          id={`dismiss-message-${messageId}`}
          checked={isDismissedChecked}
          onCheckedChange={(checked) => setIsDismissedChecked(!!checked)}
        />
        <label
          htmlFor={`dismiss-message-${messageId}`}
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          Dismiss this message permanently
        </label>
      </div>
      <Button onClick={handleActionClick} className="w-full">
        {isDismissedChecked ? 'Save & Dismiss' : 'Close'}
      </Button>
    </div>
  );
};

export default ToastContentWithCheckbox;